/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { IVisitor } from '../../visitors/IVisitor';
import { IExternalDocumentationParent } from './IExternalDocumentationParent';
import { ExternalDocumentation } from './ExternalDocumentation';

/**
 * Constructor.
 * @param {string} opType
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class Operation extends ExtensibleNode implements IExternalDocumentationParent {
    _type : string;

    public operationId : string;

    public summary : string;

    public description : string;

    public externalDocs : ExternalDocumentation;

    public constructor(opType : string) {
        super();
        if(this._type===undefined) this._type = null;
        if(this.operationId===undefined) this.operationId = null;
        if(this.summary===undefined) this.summary = null;
        if(this.description===undefined) this.description = null;
        if(this.externalDocs===undefined) this.externalDocs = null;
        this._type = opType;
    }

    /**
     * Gets the operation type.
     * @return {string}
     */
    public getType() : string {
        return this._type;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitOperation(this);
    }

    /**
     * Creates an External Documentation node.
     * @return {ExternalDocumentation}
     */
    public abstract createExternalDocumentation() : ExternalDocumentation;

    public setExternalDocumentation$io_apicurio_datamodels_core_models_common_ExternalDocumentation(externalDocs : ExternalDocumentation) {
        this.externalDocs = externalDocs;
    }

    public setExternalDocumentation$java_lang_String$java_lang_String(description : string, url : string) : ExternalDocumentation {
        let ed : ExternalDocumentation = this.createExternalDocumentation();
        ed.description = description;
        ed.url = url;
        this.externalDocs = ed;
        return ed;
    }

    /**
     * Sets the external documentation information.
     * @param {string} description
     * @param {string} url
     * @return {ExternalDocumentation}
     */
    public setExternalDocumentation(description? : any, url? : any) : any {
        if(((typeof description === 'string') || description === null) && ((typeof url === 'string') || url === null)) {
            return <any>this.setExternalDocumentation$java_lang_String$java_lang_String(description, url);
        } else if(((description != null && description instanceof <any>ExternalDocumentation) || description === null) && url === undefined) {
            return <any>this.setExternalDocumentation$io_apicurio_datamodels_core_models_common_ExternalDocumentation(description);
        } else throw new Error('invalid overload');
    }
}
Operation["__class"] = "io.apicurio.datamodels.core.models.common.Operation";
Operation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];




